import data from '@/config/issuing_authority'
import { IBGE } from './ibge'

const map = { ...data.federal, ...data.state }
const cityMap = data.municipal

const label = (key) => {
  const name = map[key]
  if (name) return name

  const code = cityMap[key]
  if (code) key = code

  const city = IBGE.getByCityCode(key)
  if (city)
    return `${city.name}/${city.initials}`
  else if (key)
    return key
  else
    return ''
}

const table = () => {
  const list = []
  Object.entries(map).forEach(([key, value]) => list.push([value, key]))
  IBGE.table.forEach(city => list.push([`${city.name}/${city.initials}`, city.cityCode]))

  const listUF = [
      'AC', 'AL', 'AM', 'AP', 'BA', 'CE', 'DF', 'ES', 'GO', 'MA',
      'MG', 'MS', 'MT', 'PA', 'PB', 'PE', 'PI', 'PR', 'RJ', 'RN',
      'RO', 'RR', 'RS', 'SC', 'SE', 'SP', 'TO']

  listUF.forEach(state => {
    const code = `SEFAZ/${state}`
    list.push([code, code])
  })

  return list
}
const IssuingAuthority = {
  label,
  table
}

export { IssuingAuthority }
